// extracted by mini-css-extract-plugin
export var activeDot = "_68-c";
export var buttonContainer = "_68-9";
export var channelButton = "_68-a";
export var clickable = "_68-d";
export var content = "_68-0";
export var contentFull = "_68-2";
export var contentThird = "_68-1";
export var contentWrapper = "_68-7";
export var description = "_68-5";
export var heightShort = "_68-f";
export var image = "_68-3";
export var imageContainer = "_68-4";
export var selectButton = "_68-e";
export var spinnerContainer = "_68-b";
export var titleContent = "_68-8";
export var titleWrapper = "_68-6";